import { Box, Button } from '@mui/material';
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { NamespacesList } from 'core/enums/common';

import { ReactComponent as Stars } from 'assets/icons/stars.svg';

interface IRegenerateMessageProps {
	handleRegenerateAccept: () => void;
	isDisabled: boolean;
}

export const RegenerateMessage: FC<IRegenerateMessageProps> = memo(
	({ handleRegenerateAccept, isDisabled }) => {
		const { t: commonTranslate } = useTranslation(NamespacesList['common']);

		return (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					marginTop: '8px',
					gap: '8px',
				}}
			>
				<Button
					data-testid={'regenerate-accept'}
					sx={{
						height: '32px',
						width: '127px',
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '14px',
						padding: '8px 12px',
						fontWeight: '700',
						background: '#4786FF',
						'&:hover': {
							background: '#4786FF',
						},
					}}
					variant="contained"
					disabled={isDisabled}
					onClick={handleRegenerateAccept}
				>
					<Stars style={{ marginRight: '4px', width: '20px' }} />
					{commonTranslate('buttons.regenerate')}
				</Button>
			</Box>
		);
	}
);
